var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-avatar',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pointer",attrs:{"variant":_vm.variant,"text":_vm.initials,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }